import {ShippingMethodsKeys} from '@libs/utils/const'
import {removeInfoKeys} from '@libs/utils/checkout'

window.addEventListener(
  'RemixAddToCart',
  (event) => {
    Object.values(ShippingMethodsKeys).forEach(keys => {
      removeInfoKeys(keys)
    })
  },
  { once: true }
)
